import { FC, SVGProps } from 'react'
import theme from 'theme'

type Props = SVGProps<SVGSVGElement> & {
  sx?: Record<string, unknown>
}

const ExitPredictionModeIcon: FC<Props> = ({ ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.84849 6.88318C2.47858 4.1764 6.27303 0 6.27303 0C0.2667 0.699087 -2.32288 8.38896 2.55052 12.3504L2.5865 10.9343C3.52161 11.974 4.67259 12.0636 4.67259 12.0636C3.93526 11.4542 3.93526 10.0919 3.93526 10.0919C5.12216 11.4183 6.39887 10.9343 6.39887 10.9343C4.90625 10.4504 5.01413 8.9267 5.01413 8.9267C7.62164 9.37482 7.51381 11.2032 7.51381 11.2032C6.65059 13.7665 3.62944 13.1032 3.62944 13.1032C7.26207 15.3079 12.1534 13.2107 13.5383 9.39268C14.941 5.59257 13.0348 1.03948 9.34816 1.89995C9.25825 1.09336 10.1934 0.448017 10.1934 0.448017C8.07139 1.1292 8.2152 2.13294 8.2152 2.13294L7.47787 1.16498L7.6577 2.79615L7.20813 4.69618C7.63974 6.04059 8.48494 5.61038 9.00646 4.5528C12.1177 3.96124 10.8048 9.01609 6.84841 6.88309L6.84849 6.88318Z"
      fill={theme.colors.textPrimary}
    />
  </svg>
)

export default ExitPredictionModeIcon
